import React from "react";

//Custom Portal Components
import TicketsSection from "../components/TicketsComponents/TicketsSection";

//Styles
import "./StyledPages/TicketsPage.css";

/**
 * Página de Tickets. Muestra el título de la sección y la tabla con todos los
 * tickets generados (mismo estilo que la tabla de contactos).
 */
export default function TicketsPage() {
    return (
        <div className="tickets-page">
            <h2 className="tickets-page-title">Tickets</h2>
            <TicketsSection />
        </div>
    );
}
